/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthRouteImport } from "./routes/_auth"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthForgotPasswordRouteImport } from "./routes/_auth/forgot-password"
import { Route as AuthLoginRouteImport } from "./routes/_auth/login"
import { Route as AuthResetPasswordRouteImport } from "./routes/_auth/reset-password"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as AuthenticatedSplatRouteImport } from "./routes/_authenticated/$"
import { Route as AuthenticatedAdminRouteImport } from "./routes/_authenticated/_admin"
import { Route as AuthenticatedCompaniesRouteImport } from "./routes/_authenticated/companies"
import { Route as AuthenticatedEtsRouteImport } from "./routes/_authenticated/ets"
import { Route as AuthenticatedHomeRouteImport } from "./routes/_authenticated/home"
import { Route as AuthenticatedMailRouteImport } from "./routes/_authenticated/mail"
import { Route as AuthenticatedMarketDataRouteImport } from "./routes/_authenticated/market-data"
import { Route as AuthenticatedTradingRouteImport } from "./routes/_authenticated/trading"
import { Route as AuthenticatedAdminAdminRouteImport } from "./routes/_authenticated/_admin/admin"
import { Route as AuthenticatedAdminFinanceRouteImport } from "./routes/_authenticated/_admin/finance"
import { Route as AuthenticatedCompaniesIndexRouteImport } from "./routes/_authenticated/companies/index"
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from "./routes/_authenticated/companies/$companyId"
import { Route as AuthenticatedEtsIndexRouteImport } from "./routes/_authenticated/ets/index"
import { Route as AuthenticatedMailIndexRouteImport } from "./routes/_authenticated/mail/index"
import { Route as AuthenticatedMailSlugRouteImport } from "./routes/_authenticated/mail/$slug"

const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: "/_admin",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: "/companies",
  path: "/companies",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEtsRoute = AuthenticatedEtsRouteImport.update({
  id: "/ets",
  path: "/ets",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMailRoute = AuthenticatedMailRouteImport.update({
  id: "/mail",
  path: "/mail",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMarketDataRoute = AuthenticatedMarketDataRouteImport.update({
  id: "/market-data",
  path: "/market-data",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTradingRoute = AuthenticatedTradingRouteImport.update({
  id: "/trading",
  path: "/trading",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminAdminRoute = AuthenticatedAdminAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminFinanceRoute =
  AuthenticatedAdminFinanceRouteImport.update({
    id: "/finance",
    path: "/finance",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: "/$companyId",
    path: "/$companyId",
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)
const AuthenticatedEtsIndexRoute = AuthenticatedEtsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedEtsRoute,
} as any)
const AuthenticatedMailIndexRoute = AuthenticatedMailIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedMailRoute,
} as any)
const AuthenticatedMailSlugRoute = AuthenticatedMailSlugRouteImport.update({
  id: "/$slug",
  path: "/$slug",
  getParentRoute: () => AuthenticatedMailRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/login": typeof AuthLoginRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/$": typeof AuthenticatedSplatRoute
  "/companies": typeof AuthenticatedCompaniesRouteWithChildren
  "/ets": typeof AuthenticatedEtsRouteWithChildren
  "/home": typeof AuthenticatedHomeRoute
  "/mail": typeof AuthenticatedMailRouteWithChildren
  "/market-data": typeof AuthenticatedMarketDataRoute
  "/trading": typeof AuthenticatedTradingRoute
  "/admin": typeof AuthenticatedAdminAdminRoute
  "/finance": typeof AuthenticatedAdminFinanceRoute
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute
  "/mail/$slug": typeof AuthenticatedMailSlugRoute
  "/companies/": typeof AuthenticatedCompaniesIndexRoute
  "/ets/": typeof AuthenticatedEtsIndexRoute
  "/mail/": typeof AuthenticatedMailIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof AuthenticatedIndexRoute
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/login": typeof AuthLoginRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/$": typeof AuthenticatedSplatRoute
  "/home": typeof AuthenticatedHomeRoute
  "/market-data": typeof AuthenticatedMarketDataRoute
  "/trading": typeof AuthenticatedTradingRoute
  "/admin": typeof AuthenticatedAdminAdminRoute
  "/finance": typeof AuthenticatedAdminFinanceRoute
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute
  "/mail/$slug": typeof AuthenticatedMailSlugRoute
  "/companies": typeof AuthenticatedCompaniesIndexRoute
  "/ets": typeof AuthenticatedEtsIndexRoute
  "/mail": typeof AuthenticatedMailIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_auth": typeof AuthRouteWithChildren
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/_auth/forgot-password": typeof AuthForgotPasswordRoute
  "/_auth/login": typeof AuthLoginRoute
  "/_auth/reset-password": typeof AuthResetPasswordRoute
  "/_authenticated/$": typeof AuthenticatedSplatRoute
  "/_authenticated/_admin": typeof AuthenticatedAdminRouteWithChildren
  "/_authenticated/companies": typeof AuthenticatedCompaniesRouteWithChildren
  "/_authenticated/ets": typeof AuthenticatedEtsRouteWithChildren
  "/_authenticated/home": typeof AuthenticatedHomeRoute
  "/_authenticated/mail": typeof AuthenticatedMailRouteWithChildren
  "/_authenticated/market-data": typeof AuthenticatedMarketDataRoute
  "/_authenticated/trading": typeof AuthenticatedTradingRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/_admin/admin": typeof AuthenticatedAdminAdminRoute
  "/_authenticated/_admin/finance": typeof AuthenticatedAdminFinanceRoute
  "/_authenticated/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRoute
  "/_authenticated/mail/$slug": typeof AuthenticatedMailSlugRoute
  "/_authenticated/companies/": typeof AuthenticatedCompaniesIndexRoute
  "/_authenticated/ets/": typeof AuthenticatedEtsIndexRoute
  "/_authenticated/mail/": typeof AuthenticatedMailIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/$"
    | "/companies"
    | "/ets"
    | "/home"
    | "/mail"
    | "/market-data"
    | "/trading"
    | "/admin"
    | "/finance"
    | "/companies/$companyId"
    | "/mail/$slug"
    | "/companies/"
    | "/ets/"
    | "/mail/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/$"
    | "/home"
    | "/market-data"
    | "/trading"
    | "/admin"
    | "/finance"
    | "/companies/$companyId"
    | "/mail/$slug"
    | "/companies"
    | "/ets"
    | "/mail"
  id:
    | "__root__"
    | "/_auth"
    | "/_authenticated"
    | "/_auth/forgot-password"
    | "/_auth/login"
    | "/_auth/reset-password"
    | "/_authenticated/$"
    | "/_authenticated/_admin"
    | "/_authenticated/companies"
    | "/_authenticated/ets"
    | "/_authenticated/home"
    | "/_authenticated/mail"
    | "/_authenticated/market-data"
    | "/_authenticated/trading"
    | "/_authenticated/"
    | "/_authenticated/_admin/admin"
    | "/_authenticated/_admin/finance"
    | "/_authenticated/companies/$companyId"
    | "/_authenticated/mail/$slug"
    | "/_authenticated/companies/"
    | "/_authenticated/ets/"
    | "/_authenticated/mail/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/forgot-password": {
      id: "/_auth/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/login": {
      id: "/_auth/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/reset-password": {
      id: "/_auth/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/$": {
      id: "/_authenticated/$"
      path: "/$"
      fullPath: "/$"
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/_admin": {
      id: "/_authenticated/_admin"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/companies": {
      id: "/_authenticated/companies"
      path: "/companies"
      fullPath: "/companies"
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/ets": {
      id: "/_authenticated/ets"
      path: "/ets"
      fullPath: "/ets"
      preLoaderRoute: typeof AuthenticatedEtsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/home": {
      id: "/_authenticated/home"
      path: "/home"
      fullPath: "/home"
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/mail": {
      id: "/_authenticated/mail"
      path: "/mail"
      fullPath: "/mail"
      preLoaderRoute: typeof AuthenticatedMailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/market-data": {
      id: "/_authenticated/market-data"
      path: "/market-data"
      fullPath: "/market-data"
      preLoaderRoute: typeof AuthenticatedMarketDataRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/trading": {
      id: "/_authenticated/trading"
      path: "/trading"
      fullPath: "/trading"
      preLoaderRoute: typeof AuthenticatedTradingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/_admin/admin": {
      id: "/_authenticated/_admin/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminAdminRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/_admin/finance": {
      id: "/_authenticated/_admin/finance"
      path: "/finance"
      fullPath: "/finance"
      preLoaderRoute: typeof AuthenticatedAdminFinanceRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/companies/": {
      id: "/_authenticated/companies/"
      path: "/"
      fullPath: "/companies/"
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
    "/_authenticated/companies/$companyId": {
      id: "/_authenticated/companies/$companyId"
      path: "/$companyId"
      fullPath: "/companies/$companyId"
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
    "/_authenticated/ets/": {
      id: "/_authenticated/ets/"
      path: "/"
      fullPath: "/ets/"
      preLoaderRoute: typeof AuthenticatedEtsIndexRouteImport
      parentRoute: typeof AuthenticatedEtsRoute
    }
    "/_authenticated/mail/": {
      id: "/_authenticated/mail/"
      path: "/"
      fullPath: "/mail/"
      preLoaderRoute: typeof AuthenticatedMailIndexRouteImport
      parentRoute: typeof AuthenticatedMailRoute
    }
    "/_authenticated/mail/$slug": {
      id: "/_authenticated/mail/$slug"
      path: "/$slug"
      fullPath: "/mail/$slug"
      preLoaderRoute: typeof AuthenticatedMailSlugRouteImport
      parentRoute: typeof AuthenticatedMailRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAdminRoute: typeof AuthenticatedAdminAdminRoute
  AuthenticatedAdminFinanceRoute: typeof AuthenticatedAdminFinanceRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAdminRoute: AuthenticatedAdminAdminRoute,
  AuthenticatedAdminFinanceRoute: AuthenticatedAdminFinanceRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedCompaniesRouteChildren {
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
}

const AuthenticatedCompaniesRouteChildren: AuthenticatedCompaniesRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
    AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  }

const AuthenticatedCompaniesRouteWithChildren =
  AuthenticatedCompaniesRoute._addFileChildren(
    AuthenticatedCompaniesRouteChildren,
  )

interface AuthenticatedEtsRouteChildren {
  AuthenticatedEtsIndexRoute: typeof AuthenticatedEtsIndexRoute
}

const AuthenticatedEtsRouteChildren: AuthenticatedEtsRouteChildren = {
  AuthenticatedEtsIndexRoute: AuthenticatedEtsIndexRoute,
}

const AuthenticatedEtsRouteWithChildren =
  AuthenticatedEtsRoute._addFileChildren(AuthenticatedEtsRouteChildren)

interface AuthenticatedMailRouteChildren {
  AuthenticatedMailSlugRoute: typeof AuthenticatedMailSlugRoute
  AuthenticatedMailIndexRoute: typeof AuthenticatedMailIndexRoute
}

const AuthenticatedMailRouteChildren: AuthenticatedMailRouteChildren = {
  AuthenticatedMailSlugRoute: AuthenticatedMailSlugRoute,
  AuthenticatedMailIndexRoute: AuthenticatedMailIndexRoute,
}

const AuthenticatedMailRouteWithChildren =
  AuthenticatedMailRoute._addFileChildren(AuthenticatedMailRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRouteWithChildren
  AuthenticatedEtsRoute: typeof AuthenticatedEtsRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedMailRoute: typeof AuthenticatedMailRouteWithChildren
  AuthenticatedMarketDataRoute: typeof AuthenticatedMarketDataRoute
  AuthenticatedTradingRoute: typeof AuthenticatedTradingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRouteWithChildren,
  AuthenticatedEtsRoute: AuthenticatedEtsRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedMailRoute: AuthenticatedMailRouteWithChildren,
  AuthenticatedMarketDataRoute: AuthenticatedMarketDataRoute,
  AuthenticatedTradingRoute: AuthenticatedTradingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
